import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Card, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const RegistrationTokenActions = require('../../actions/registration_token_actions');
const RegistrationTokenStore = require('../../stores/registration_token_store');
const ValidateUtil = require('../../util/ValidateUtil');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';

const propTypes = {
    token: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        token: PropTypes.string.isRequired,
        example_project_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        example_project_name: PropTypes.string,
    }).isRequired
};

const defaultProps = {};

class RegTokenProjectListing extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.projectId = React.createRef();
        this.projectName = React.createRef();

        this.updateTokenHandler = this.updateTokenHandler.bind(this);
        this.unsubscribes = [RegistrationTokenStore.listen(this.onRegistrationTokenStoreStateChagne.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onRegistrationTokenStoreStateChagne(state) {
        let additionalState = ValidateUtil.getUpdatedState(this.state.actionID, state);
        this.setState({ registrationTokenStoreState: state, ...additionalState });
    }

    updateTokenHandler() {
        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            RegistrationTokenActions.updateRegTokenProject(actionID, {
                id: this.props.token.id,
                exampleProjectName: this.projectName.current.value,
                exampleProjectId: this.projectId.current.value,
            });
        });

    }

    render() {
        return (
            <Card body bg="light">
                <h3>({this.props.token.id}) {this.props.token.token}</h3>
                <div style={{ fontSize: "12px" }}>(If blank, default example project will be used)</div>

                {this.state.actionSuccess ? <SuccessBox message={this.state.successMessage}/> : null}
                <ErrorBox error={this.state.error}/>

                <Form>
                    <Form.Group controlId={`admin-tmpl-projectid-${this.props.token.id}`}>
                        <Form.Label>Example Project ID</Form.Label>
                        <Form.Control
                            type="number"
                            ref={this.projectId}
                            defaultValue={this.props.token.example_project_id}
                            isInvalid={ValidateUtil.isInvalid(this.state, 'projectId')}
                        />
                    </Form.Group>

                    <Form.Group controlId={`admin-tmpl-projname-${this.props.token.id}`}>
                        <Form.Label>Example Project Name</Form.Label>
                        <Form.Control
                            type="text"
                            ref={this.projectName}
                            defaultValue={this.props.token.example_project_name}
                            isInvalid={ValidateUtil.isInvalid(this.state, 'projectName')}
                        />
                    </Form.Group>

                    <Button onClick={this.updateTokenHandler.bind(this, this.props.token.id)}>
                        Update Token
                    </Button>
                </Form>
            </Card>
        )
    }
}

RegTokenProjectListing.propTypes = propTypes;
RegTokenProjectListing.defaultProps = defaultProps;

export default RegTokenProjectListing;